import { createSlice } from "@reduxjs/toolkit";
import privacyPolicy from "../Services/PrivacyPolicy.Services";

const initialState = {
    getPrivacyPolicy: [],
    loading: false,
    error: false,
    success: false,
  };


  const privacyPolicySlice = createSlice({
    name: "privacyPolicy",
    initialState,
    // reducers: {
    //   setCmsPageInfo: (state, action) => {
    //     state.cmsPages = action?.payload?.cmsPages;
    //   },
    //   setSuccess: (state, action) => {
    //     state.success = action?.payload;
    //   },
    // },
    extraReducers: {
      [privacyPolicy.pending]: (state, action) => {
        state.loading = true;
      },
      [privacyPolicy.fulfilled]: (state, action) => {
        state.getPrivacyPolicy = action.payload?.privacy;
        state.loading = false;
      },
      [privacyPolicy.rejected]: (state, action) => {
        state.getPrivacyPolicy = action.payload?.privacy;
        state.loading = false;
      },
    },
  });
  export const { privacyPolicyPage } = privacyPolicySlice.actions;
  export default privacyPolicySlice.reducer;
    